import { render } from "./DialogReading.vue?vue&type=template&id=3d3bcf2b"
import script from "./DialogReading.vue?vue&type=script&lang=js"
export * from "./DialogReading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__